export default __webpack_public_path__ + "static/media/MTcarpaEspecial_LateralIzq.93d64204.webp";